import footerNavigation from './footer-navigation'

// ===========================|| Footer Items ||=========================== //

const menuItems = {
  items: [footerNavigation]
}

export default menuItems
